export class ProcessedDocumentSuggestionModel {
    id: number;
    name: string;
    description: string;
    chunkId: number;
    selected?: boolean;
    isDoneProcessing: boolean;
    linkedGuid: string;
}
